import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import withSelectedDeviations, {
  WithSelectedDeviationsProps,
} from '../../_hocs/withSelectedDeviations';
import { PapiDeviation } from '@wix/da-papi-types';
import IndicatorForDeviationThumb from '../IndicatorForDeviationThumb';
import s from './SelectableDeviationWrapper.scss';

export interface Props {
  deviation: PapiDeviation;
  children: React.ReactNode;
  isDisabled?: boolean;
  className?: string;
}

const enhance = compose(withSelectedDeviations);

export class SelectableDeviationWrapper extends React.Component<
  Props & WithSelectedDeviationsProps
> {
  render() {
    const {
      deviation,
      selectionLimit,
      selectedDeviations,
      canSelectMore,
      className,
    } = this.props;

    const isSelected = !!selectedDeviations.find(
      selectedDeviation =>
        selectedDeviation.typeId === deviation.typeId &&
        selectedDeviation.deviationId === deviation.deviationId
    );
    const isDisabled =
      this.props.isDisabled ||
      (selectionLimit > 1 && !isSelected && !canSelectMore);

    return (
      <div
        className={classnames(
          s['root'],
          isSelected && s['selected'],
          isDisabled && s['disabled'],
          className
        )}
        draggable={false}
        onClick={this.onToggleSelect}
      >
        {isSelected && <CheckIcon className={s['check']} />}
        <IndicatorForDeviationThumb
          deviation={deviation}
          className={s['indicator']}
        />
        {this.props.children}
      </div>
    );
  }
  onToggleSelect = () => {
    this.props.onSelectableItemClick(this.props.deviation);
  };
}

export default enhance(
  SelectableDeviationWrapper
) as any as React.ComponentClass<Props>;
